import {
  ADD_NOTE,
  REMOVE_NOTE,
  LOG_ME,
  NEW_PROJECT,
  CLEAR_CURRENT_PROJECT,
  NEW_USER,
  ADD_ERROR,
  REMOVE_ERROR,
  SUCCESS_GET_ALL_PROJECTS_FOR_ADMIN,
  SUCCESS_GET_ALL_USERS_FOR_ADMIN,
  SUCCESS_GET_ALL_USERS_IN_STAGE_FOR_ADMIN,
  SUCCESS_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN,
  SUCCESS_GET_PROJECT_DATA,
  SUCCESS_GET_USER_DATA_FOR_ADMIN,
  SUCCESS_GET_AUTH_USER_DATA,
  SUCCESS_GET_USER_ACTIVE_PROJECT_TREE_DATA,
  SUCCESS_GET_USER_INACTIVE_PROJECT_TREE_DATA,
  SUCCESS_GET_TIME_SHEET_DATA,
  SUCCESS_GET_ALL_INCOME_EXPENSE,
  SUCCESS_GET_INCOME_EXPENSE_BALANCE,
  SUCCESS_GET_CALENDAR_DATA,
  SUCCESS_GET_ALL_ACTIVITIES,
  SUCCESS_GET_ACTIVITY_DATA,
  NEW_ACTIVITY,
  CLEAR_CURRENT_ACTIVITY,
  SUCCESS_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN,
  SUCCESS_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN,
  SUCCESS_GET_USER_ACTIVITIES_DATA,
  SET_SHOW_TEAM_IN_TIMESHEET,
  SELECT_USER_FOR_TIMESHEET,
  SUCCESS_GET_TIME_SHEET_DATA_OF_USER,
  SUCCESS_GET_HOLIDAY_INFO,
  SUCCESS_GET_USER_DATA_FOR_SELF,
  SUCCESS_GET_SELF_STATS,
  SUCCESS_GET_All_USERS_STATS,
  SUCCESS_GET_SELF_CLAIMS,
  SUCCESS_GET_USER_CLAIMS,
  LOADING_GET_STAGE_STATS,
  SUCCESS_GET_STAGE_STATS,
  LOADING_GET_PROJECT_STATS,
  SUCCESS_GET_PROJECT_STATS,
  LOADING_GET_ACTIVITY_STATS,
  SUCCESS_GET_ACTIVITY_STATS,
} from '../constants/constants';

const initialState = {
  notes: ['note 1'],
  errors: [],
  currentProject: {
    stages: [],
  },
  projects: [],
  users: [],
  usersInStage: [],
  usersNotInStage: [],
  currentUser: {},
  currentUserActiveProjectData: [],
  currentUserInactiveProjectData: [],
  currentUserClaims: [],
  timeSheet: [],
  incomeAndExpense: [],
  incomeAndExpenseBalance: 0,
  calendarData: {},
  activities: [],
  currentActivity: {},
  usersInActivity: [],
  usersNotInActivity: [],
  currentUserActivitiesData: [],
  showTeamInTimeSheet: false,
  selectedUserIdForTimeSheet: '',
  holidayInfo: [],
  selfData: {
    leftVacationDays: 0,
    availableOvertime: 0,
  },
  selfStats: [],
  allUsersStats: [],
  selfClaims: [],
  stageStats: {
    isLoading: false,
    actualIncome: 0,
    leftWorkDays: 0,
    profitableDaysLeft: 0,
    projectedIncome: 0,
    spentHours: 0,
    totalCost: 0,
  },
  projectStats: {
    isLoading: false,
    actualIncome: 0,
    totalCost: 0,
    spentHours: 0,
  },
  activityStats: {
    isLoading: false,
    totalCost: 0,
    spentHours: 0,
  },
};

function rootReducer(state = initialState, action) {
  if (action.type.includes('FAIL')) {
    // TODO not best solution
    // same as ADD_ERROR
    // create generic error
    return {
      ...state,
      errors: [
        ...state.errors,
        {
          title: 'Error',
          content:
            'There is an error with your request. Please contact support.',
        },
      ],
    };
  }
  switch (action.type) {
    case LOG_ME:
      return { ...state };
    case ADD_ERROR:
      return {
        ...state,
        errors: [
          ...state.errors,
          {
            title: 'Error',
            content:
              'There is an error with your request. Please contact support.',
          },
        ],
      };
    case REMOVE_ERROR:
      return {
        ...state,
        errors: [],
      };
    case SUCCESS_GET_ALL_PROJECTS_FOR_ADMIN:
      return {
        ...state,
        projects: action.response.data,
      };
    case SUCCESS_GET_ALL_USERS_FOR_ADMIN:
      return {
        ...state,
        users: action.response.data,
      };
    case SUCCESS_GET_ALL_USERS_IN_STAGE_FOR_ADMIN:
      return {
        ...state,
        usersInStage: action.response.data,
      };
    case SUCCESS_GET_ALL_USERS_NOT_IN_STAGE_FOR_ADMIN:
      return {
        ...state,
        usersNotInStage: action.response.data,
      };
    case SUCCESS_GET_PROJECT_DATA:
      return {
        ...state,
        currentProject: action.response.data,
      };
    case SUCCESS_GET_USER_DATA_FOR_ADMIN:
      return {
        ...state,
        currentUser: action.response.data,
      };
    case SUCCESS_GET_AUTH_USER_DATA:
      return {
        ...state,
        authenticatedUserData: action.response.data,
      };
    case SUCCESS_GET_USER_ACTIVE_PROJECT_TREE_DATA:
      return {
        ...state,
        currentUserActiveProjectData: action.response.data,
      };
    case SUCCESS_GET_USER_INACTIVE_PROJECT_TREE_DATA:
      return {
        ...state,
        currentUserInactiveProjectData: action.response.data,
      };
    case NEW_PROJECT:
      return {
        ...state,
        currentProject: {
          status: 'active',
          stages: [],
          newProject: true,
        },
        currentProjectIsEditing: true,
      };
    case CLEAR_CURRENT_PROJECT:
      return {
        ...state,
        currentProject: { stages: [] },
      };
    case NEW_USER:
      return {
        ...state,
        currentUser: { role: 'user', status: 'active', newUser: true },
      };
    case SUCCESS_GET_TIME_SHEET_DATA:
      return {
        ...state,
        timeSheet: action.response.data,
      };
    case SUCCESS_GET_TIME_SHEET_DATA_OF_USER:
      return {
        ...state,
        timeSheet: action.response.data,
      };
    case SUCCESS_GET_ALL_INCOME_EXPENSE:
      return {
        ...state,
        incomeAndExpense: action.response.data,
      };
    case SUCCESS_GET_INCOME_EXPENSE_BALANCE:
      return {
        ...state,
        incomeAndExpenseBalance: action.response.data,
      };
    case SUCCESS_GET_CALENDAR_DATA:
      return {
        ...state,
        calendarData: action.response.data,
      };
    case SUCCESS_GET_ALL_ACTIVITIES:
      return {
        ...state,
        activities: action.response.data,
      };
    case SUCCESS_GET_ACTIVITY_DATA:
      return {
        ...state,
        currentActivity: action.response.data,
      };
    case NEW_ACTIVITY:
      return {
        ...state,
        currentActivity: {
          newActivity: true,
        },
        currentActivityIsEditing: true,
      };
    case CLEAR_CURRENT_ACTIVITY:
      return {
        ...state,
        currentActivity: {},
      };
    case SUCCESS_GET_ALL_USERS_IN_ACTIVITY_FOR_ADMIN:
      return {
        ...state,
        usersInActivity: action.response.data,
      };
    case SUCCESS_GET_ALL_USERS_NOT_IN_ACTIVITY_FOR_ADMIN:
      return {
        ...state,
        usersNotInActivity: action.response.data,
      };
    case SUCCESS_GET_USER_ACTIVITIES_DATA:
      return {
        ...state,
        currentUserActivitiesData: action.response.data,
      };
    case ADD_NOTE:
      return {
        notes: [
          ...state.notes,
          {
            title: action.title,
            content: action.content,
          },
        ],
      };
    case REMOVE_NOTE:
      return {
        notes: state.notes.filter((note, index) => index !== action.id),
      };
    case SET_SHOW_TEAM_IN_TIMESHEET:
      return {
        ...state,
        showTeamInTimeSheet: action.payload,
      };
    case SELECT_USER_FOR_TIMESHEET:
      return {
        ...state,
        selectedUserIdForTimeSheet: action.payload,
      };
    case SUCCESS_GET_HOLIDAY_INFO:
      return {
        ...state,
        holidayInfo: action.response.data,
      };
    case SUCCESS_GET_USER_DATA_FOR_SELF:
      return {
        ...state,
        selfData: action.response.data,
      };
    case SUCCESS_GET_SELF_STATS:
      return {
        ...state,
        selfStats: action.response.data,
      };
    case SUCCESS_GET_All_USERS_STATS:
      return {
        ...state,
        allUsersStats: action.response.data,
      };
    case SUCCESS_GET_SELF_CLAIMS:
      return {
        ...state,
        selfClaims: action.response.data,
      };
    case SUCCESS_GET_USER_CLAIMS:
      return {
        ...state,
        currentUserClaims: action.response.data,
      };
    case LOADING_GET_STAGE_STATS:
      return {
        ...state,
        stageStats: { ...state.stageStats, isLoading: true },
      };
    case SUCCESS_GET_STAGE_STATS:
      return {
        ...state,
        stageStats: { ...action.response.data, isLoading: false },
      };
    case LOADING_GET_PROJECT_STATS:
      return {
        ...state,
        projectStats: { ...state.projectStats, isLoading: true },
      };
    case SUCCESS_GET_PROJECT_STATS:
      return {
        ...state,
        projectStats: { ...action.response.data, isLoading: false },
      };
    case LOADING_GET_ACTIVITY_STATS:
      return {
        ...state,
        activityStats: { ...state.activityStats, isLoading: true },
      };
    case SUCCESS_GET_ACTIVITY_STATS:
      return {
        ...state,
        activityStats: { ...action.response.data, isLoading: false },
      };
    default:
      return state;
  }
}

export default rootReducer;
